export default {
    data() {
        return {
            planos: [
                { value: 0, text: 'Todos' },
                { value: 1, text: 'Teste 30 dias' },
                { value: 2, text: 'Plano Bronze' },
                { value: 3, text: 'Plano Prata' },
                { value: 4, text: 'Plano Ouro' },
                { value: 5, text: 'Plano Diamante' },
            ],
        }}
}